import {
  arrayBuilderItemSubsequentPageTitleUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import MedicareCardDescription from '../../components/FormDescriptions/MedicareCardDescription';
import { MedicarePartsAbDescription } from '../../components/FormDescriptions/MedicarePlanDescriptions';
import { attachmentSchema, attachmentUI } from '../../definitions';
import content from '../../locales/en/content.json';
import { ATTACHMENT_IDS } from '../../utils/constants';

const TITLE_TEXT = content['medicare--parts-ab-card-title'];
const INPUT_LABELS = {
  cardFront: content['medicare--parts-ab-card-label--front'],
  cardBack: content['medicare--parts-ab-card-label--back'],
};
const HINT_TEXT = content['attachments--hint-text'];

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      TITLE_TEXT,
      MedicarePartsAbDescription,
    ),
    ...descriptionUI(MedicareCardDescription({ variant: 'partsAB' })),
    medicarePartAPartBFrontCard: attachmentUI({
      title: INPUT_LABELS.cardFront,
      hint: HINT_TEXT,
      attachmentId: ATTACHMENT_IDS.medicareAbCardFront,
    }),
    medicarePartAPartBBackCard: attachmentUI({
      title: INPUT_LABELS.cardBack,
      hint: HINT_TEXT,
      attachmentId: ATTACHMENT_IDS.medicareAbCardBack,
    }),
  },
  schema: {
    type: 'object',
    required: ['medicarePartAPartBFrontCard', 'medicarePartAPartBBackCard'],
    properties: {
      medicarePartAPartBFrontCard: attachmentSchema,
      medicarePartAPartBBackCard: attachmentSchema,
    },
  },
};
